import { maskCnpj, unmaskCnpj } from './cnpj';

const CPF_LENGTH = 11;
const CPF_SEPARATORS: Readonly<Record<number, string>> = { 3: '.', 6: '.', 9: '-' };
const DIGITS_ONLY = /^\d*$/;

/** Remove a máscara de CPF ou CNPJ e normaliza letras (até 14 caracteres alfanuméricos). */
export function unmaskTaxId(value: string): string {
  return unmaskCnpj(value);
}

/**
 * Aplica a máscara progressivamente: CPF (`000.000.000-00`) enquanto houver até 11 dígitos;
 * CNPJ (`XX.XXX.XXX/XXXX-XX`, inclusive alfanumérico) a partir do 12º caractere ou com letra.
 */
export function maskTaxId(value: string): string {
  const unmasked = unmaskTaxId(value);
  if (unmasked.length > CPF_LENGTH || !DIGITS_ONLY.test(unmasked)) return maskCnpj(unmasked);
  let masked = '';
  for (let index = 0; index < unmasked.length; index += 1) {
    masked += `${CPF_SEPARATORS[index] ?? ''}${unmasked.charAt(index)}`;
  }
  return masked;
}
